import { GridItem } from "@chakra-ui/react";
import { Fragment } from "react";
import * as React from "react";

function MissingDataGridItems({ value }) {
  return (
    <Fragment>
      <GridItem></GridItem>
      <GridItem display="flex" justifyContent="end" textAlign="right" alignItems="center">{value}</GridItem>
      <GridItem display="flex" justifyContent="end" textAlign="right" alignItems="center">{value}</GridItem>
    </Fragment>
  );
}

export default MissingDataGridItems;